import React from 'react';
import PropTypes from 'prop-types';

export default class RadioButtonComponent extends React.Component {
    static propTypes = {
      optionSelected: PropTypes.string.isRequired,
      onChangeFunctionCall: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      uniqueKey: PropTypes.number
    };

    handleOptionChange = (changeEvent) => {
      this.props.onChangeFunctionCall(changeEvent.target.value);
    }

    render() {
      return (
        <div className="radio">
          <label>
            <input type="radio" value={this.props.value}
              name = "radio"
              checked = {this.props.value === this.props.optionSelected}
              onChange={this.handleOptionChange}
              key = {this.props.uniqueKey}
            />
            {this.props.label}
          </label>
        </div>
      );
    }
}


// WEBPACK FOOTER //
// src/Components/RadioButtonComponent.jsx